import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useWindowWidth } from '@awaze/design-system.utils.react';
import { TmsContext } from './tms-context';
import { initTms, calculateSiteUXVersion, pushToDataLayer, } from './tms-context.utils';
export function TmsProvider({ children, id = 'GTM-WGJBHL4', gtmDataLayerName = 'dataLayer', pageLoadDataObjectName = 'utag_data', pageLoadDataObject, }) {
    const [init, setInit] = useState(false);
    const width = useWindowWidth();
    const siteUxVersion = calculateSiteUXVersion(width);
    const combinedPageLoadDataObject = {
        ...pageLoadDataObject,
        site_ux_version: siteUxVersion,
    };
    useEffect(() => {
        if (width && !init) {
            initTms({
                id,
                gtmDataLayerName,
                pageLoadDataObjectName,
                pageLoadDataObject: combinedPageLoadDataObject,
            });
            setInit(true);
        }
    }, [width, init]);
    return (_jsx(TmsContext.Provider, { value: {
            id,
            gtmDataLayerName,
            pageLoadDataObjectName,
            pageLoadDataObject: combinedPageLoadDataObject,
            updateDataLayer: (eventType, eventName, eventData) => {
                const combinedEventData = {
                    ...eventData,
                    site_ux_version: calculateSiteUXVersion(window.innerWidth),
                };
                return pushToDataLayer(eventType, eventName, combinedEventData);
            },
        }, children: children }));
}
//# sourceMappingURL=tms-context-provider.js.map